import { Attempt } from '@/common/types/session';
import { formatTimeTaken } from '@/common/utils/datetime';
import { sanitize } from '@/common/utils/helpers';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import {
  CorrectChoice,
  IncorrectChoice,
  OtherOption,
  OtherOptionsCell,
} from './CellStyles';
import GenericAttemptTable, {
  getControlIcon,
  getHasControl,
} from './GenericAttemptTable';

interface WordRiftsAttemptTableProps {
  attempts: Attempt[];
}
export default function WordRiftsAttemptTable({
  attempts,
}: WordRiftsAttemptTableProps) {
  const hasControl = getHasControl(attempts);
  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Attempt</TableHead>
          <TableHead>Sentence</TableHead>
          <TableHead>Correct Choice</TableHead>
          <TableHead>Student Choice</TableHead>
          <TableHead>Cards Presented</TableHead>
          <TableHead>Time Taken</TableHead>
          {hasControl && <TableHead>Control</TableHead>}
        </TableRow>
      )}
      renderData={() =>
        attempts.map((attempt, index) => (
          <TableRow key={index} className="hover:bg-white">
            <TableCell>{index + 1}</TableCell>
            <TableCell>{attempt.context}</TableCell>
            <TableCell>{attempt.correctAnswer}</TableCell>
            <TableCell>
              {sanitize(attempt.studentAnswer) ===
              sanitize(attempt.correctAnswer) ? (
                <CorrectChoice>{attempt.studentAnswer}</CorrectChoice>
              ) : (
                <IncorrectChoice>{attempt.studentAnswer}</IncorrectChoice>
              )}
            </TableCell>
            <OtherOptionsCell>
              {(attempt.incorrectAnswers || []).map((choice, choiceIndex) => (
                <OtherOption key={choiceIndex}>{choice}</OtherOption>
              ))}
            </OtherOptionsCell>
            <TableCell>
              {formatTimeTaken(attempt.startedAt, attempt.endedAt)}
            </TableCell>
            {hasControl && (
              <TableCell className="pl-6">
                {getControlIcon(attempt.control!)}
              </TableCell>
            )}
          </TableRow>
        ))
      }
      isEmpty={attempts.length === 0}
    />
  );
}
